<div class="ipm-add-billing-sec"> 
    <a href="javascript:void(0)" class="ipm-link-button" (click)="handleAddClick()">+ Add new billing address</a>
  </div>
<div class="ipm-billing-common-sec" [class.ipm-scrolling-div]="isShowScrollbar && billingAddressList.length > 1" [class.ipm-overflow-hidden]="!isShowAllData && isShowScrollbar && billingAddressList.length > 0">
    <ng-container *ngIf="billingAddressList.length > 0; else isDataEmpty">
        <ng-container *ngFor="let  addressData of billingAddressList; let i = index">
            <div class="ipm-billing-list" [class.active]="addressData.isSelected" (click)="selectedData(i)">
                <div class="ipm-billing-details" [class.w-100]="!isShowAction">
                    <div class="ipm-text-div">
                        <span class="ipm-heading">Legal Name:</span>
                        <span class="ipm-value">{{addressData?.legal_name ? addressData?.legal_name : "Nil" }}</span>
                    </div>
                    <div class="ipm-text-div">
                        <div class="ipm-heading">Address:</div>
                        <div class="ipm-value">{{addressData?.address?.line_1}}, {{addressData?.address?.line_2}} {{addressData?.city}}, {{addressData?.state}}, {{addressData?.country}} {{addressData?.pin_code}}</div>
                    </div>
                    <div class="ipm-text-div" *ngIf="isShowCompanyName">
                        <div class="ipm-heading">Company name:</div>
                        <div class="ipm-value">{{addressData?.company_name ? addressData?.company_name : "Nil" }}</div>
                    </div>
                </div>
                <div class="ipm-edit-icon" *ngIf="isShowAction &&  (billingAddressList.length > 1 && currentUserDetails.role === 'producer') || (currentUserDetails && currentUserDetails.role !== 'producer')">
                    <!-- <i class="las la-edit" (click)="$event.stopPropagation();openAddressPop(i)"></i> -->
                    <i class="lar la-trash-alt" (click)="$event.stopPropagation();deleteBeat(i)"></i>
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>
<div class="ipm-show-more" *ngIf="billingAddressList.length > 1"><a href="javascript:void(0)" *ngIf="isShowAll" (click)="onClickShow()">{{ !isShowAllData ? 'Show All' : 'Show Less'}}</a></div>

<ng-template #addressModel let-data>
    <ipm-add-billing-address-form [currentAddressDetails]="data" [countries]="countries" [dialogType]="dialogType"></ipm-add-billing-address-form>
</ng-template>

<ng-template #isDataEmpty>
    <ipm-empty-data-message [emptyMessage]="'You have not added any billing address yet!'"  [isShowButton]="false" [messageType]="'billing-address'"></ipm-empty-data-message>
</ng-template>